import { faireBaseUrl } from '@faire/web--source/common/routes/faireBaseUrl';
import { compile } from 'path-to-regexp';
import type { IRouteMetadata } from '../../Route';

/**
 * Generated from Jersey path "/trending-on-faire"
 *
 *   New page "Popular Searches". We decided to call it /trending-on-faire since we
 *   want to void the word "search" in the url as well as the page content due to Google bias.
 * Product Area: SEO
 */
export const route = '/trending-on-faire';

export const props: IRouteMetadata & { path: string } = {
  path: route,
  templatedPath: '/trending-on-faire',
  productArea: 'SEO',
  pod: 'FAIRE_POD_RETAILER_ACQUISITION',
  pillar: 'FAIRE_PILLAR_RETAILER_GROWTH',
};

export const toPath = compile(route, {
  encode: encodeURIComponent,
});

/**
 *   New page "Popular Searches". We decided to call it /trending-on-faire since we

 *   want to void the word "search" in the url as well as the page content due to Google bias.
 */
export function path() {
  const compiledPath = toPath({});
  return compiledPath;
}

/**
 * Build a full URL of the route (including the base faire URL).
 */
export const url = (): string => {
  return faireBaseUrl(3000) + path();
};

export default path;
